import Box from "@mui/material/Box";
import { searchAlgoliaClient } from "entities/algolia/constants";
import useProtectedRoute from "entities/auth/hooks/useProtectedRoute";
import { useAuthUserStore } from "entities/auth/stores/authUserStore";
import { FC, ReactElement } from "react";
import { InstantSearch } from "react-instantsearch";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDynamicRouting } from "shared/hooks/useDynamicRouting";
import { useRoutingDataByPathname } from "shared/hooks/useRoutingDataByPathname";
import { APP_PATH, SIGN_IN_PATH } from "shared/routes/paths";
import NavigationBar from "./components/NavigationBar";
import { MainLayoutPageProvider } from "./context";
import { StyledMain } from "./styled";

export type Page = {
  path: string;
  component: ReactElement;
};

const MainLayout: FC = () => {
  const { firebaseUser } = useAuthUserStore();
  const currentRouteData = useRoutingDataByPathname();
  const location = useLocation();
  const { initialPathname } = useDynamicRouting();
  useProtectedRoute();

  if (!firebaseUser) {
    return <Navigate to={SIGN_IN_PATH} />;
  }

  if (location.pathname === APP_PATH) {
    return <Navigate to={initialPathname} replace />;
  }

  return (
    <Box display="flex">
      <MainLayoutPageProvider>
        <NavigationBar />
        <InstantSearch
          key={currentRouteData.algoliaIndexName}
          searchClient={searchAlgoliaClient}
          indexName={currentRouteData.algoliaIndexName}
          future={{ preserveSharedStateOnUnmount: true }}
        >
          <StyledMain pathname={location.pathname}>
            <Outlet />
          </StyledMain>
        </InstantSearch>
      </MainLayoutPageProvider>
    </Box>
  );
};

export default MainLayout;
